// @flow
import type { Location } from "react-router";
import React, { Component } from "react";
import cx from "classnames";
import { connect } from "react-redux";
import { getLogger } from "@cld/upload-widget";
import { asAbsolute } from "root/routes/utils";
import bindRootActions, { types as rootAts } from "root/actions";
import { getComponentConsumer } from "root/components/UploadContainer/uploaderContext";
import { selectIsThinMenu } from "root/selectors";

const logger = getLogger();

type panelOptions = { id: string, root?: boolean };

type RouteData = {
	location: Location,
	match: {
		isExact: boolean,
		pathname: string
	}
};

const isRootMatch = (route: RouteData, options: panelOptions) => options.root && route.location.pathname === asAbsolute(options.id);

const getClassNameForActivePanel = ({ route }: { route: RouteData }, options: panelOptions) => (
	(route.match && route.match.isExact) ||
	isRootMatch(route, options) ||
	route.location.pathname.indexOf(asAbsolute(options.id)) === 0 ? "active" : "");

type Props = {
	uploader: Object,
	route: RouteData,
	rootActions: { [string]: Function },
	isThinMenu: boolean,
};

export default (options: panelOptions) => (Panel: any) => {
	class TabPanelHoc extends Component<Props> {
		componentDidMount() {
			this.updateUploaderSource();
		}

		componentDidUpdate() {
			this.updateUploaderSource();
		}

		addToUploadQueue = (data: { files: any[] }) => {
			logger.log("[TabPanel]: adding file data to upload queue");

			this.props.rootActions[rootAts.ADD_UPLOAD_TO_QUEUE]({
				files: data.files,
			});
		};

		updateUploaderSource() {
			if (!options.root || isRootMatch(this.props.route, options)) {
				logger.log(`[TabPanel]: setting uploader source to: ${options.id}`);
				this.props.uploader.setCurrentSource(options.id);
				this.props.rootActions[rootAts.SET_ACTIVE_SOURCE]({ source: options.id });
			}
		}

		render() {
			const cls = cx(
				"panel",
				"content-wrap",
				"bg-source-bg bg-source-bg-c",
				options.id,
				"h-100 h-auto-ns",
				getClassNameForActivePanel(this.props, options),
				"flex",
				"items-center",
				{ "thin-menu": this.props.isThinMenu },
			);

			return <div className={cls}>
				<Panel {...this.props} addToUploadQueue={this.addToUploadQueue}/>
			</div>;
		}
	}

	TabPanelHoc.displayName = `TabPanelHOC(${options.id})`;

	return connect<Props, *, *, *, *, *>(
		(state): Object => ({ isThinMenu: selectIsThinMenu(state) }),
		(dispatch: Function): Object => ({
			rootActions: bindRootActions(dispatch),
		}),
	)(getComponentConsumer(TabPanelHoc));
};
